<a (click)="handleChange(isNextWeekChanger)" class="c-ts-week-changer__btn">
    <i
        class="u-icon"
        [ngClass]="{'u-icon-angle-left': !isNextWeekChanger, 'u-icon-angle-right': isNextWeekChanger}"
    >
    </i>
</a>
